import Checkbox from './Checkbox';
import Group from './Group';
Checkbox.Group = Group;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/checkbox/index.js
// module id = 77
// module chunks = 0